import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const BlockBackButton = () => {
  const location = useLocation();
  const [showToast, setShowToast] = useState(false);
  const backPressCount = useRef(0);

  useEffect(() => {
    const handlePopState = (event) => {
      const blockedPages = ['/curate-look', '/shop-the-look'];
      const currentPath = location.pathname;

      const isBlockedPage = blockedPages.some(page => currentPath.startsWith(page));

      if (isBlockedPage) {
        if (backPressCount.current < 3) {
          event.preventDefault();
          backPressCount.current += 1;
          setShowToast(true);

          // Stay on the same page
          window.history.pushState(null, '', window.location.href);

          // Hide toast after 2 seconds
          setTimeout(() => {
            setShowToast(false);
          }, 2000);
        } else {
          // Allow navigation after 3 blocked presses
          window.removeEventListener('popstate', handlePopState);
          window.history.back();
        }
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location]);

  return (
    <>
      {showToast && (
        <div style={toastStyles}>
          Please use the Back button inside the app.
        </div>
      )}
    </>
  );
};

// Styling for the toast
const toastStyles = {
  position: 'fixed',
  bottom: '20px',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: '#333',
  color: '#fff',
  padding: '12px 24px',
  borderRadius: '8px',
  fontSize: '14px',
  zIndex: 1000,
  opacity: 0.9,
};

export default BlockBackButton;
